import React, { FC } from 'react';
import styled from 'styled-components';

import { User } from '~/api/account/accountApiTypes';
import { MiniatureSizesEnum } from '~/api/book/bookApiTypes';
import { Avatar } from '~/atomic/atom/Avatar/Avatar';
import { TextBoldStyle, TextRegStyle } from '~/atomic/Typography';

interface SubscriberCardParams {
  subscriber: User
}

enum SubscriberRoleName {
  reader = 'читатель',
  admin = 'администратор',
  author = 'автор',
}

export const SubscriberCard: FC<SubscriberCardParams> = ({ subscriber }) => {
  return (
    <SCSubscriberCard>
      <SCAvatar
        imageSize={56}
        avatarImages={subscriber.avatarImages}
        avatarSize={MiniatureSizesEnum.L}
        alt="Аватарка пользователя"
        userName={subscriber?.name}
      />
      <SCSubscriberName>
        { subscriber?.name ?? 'Имя пользователя' }
      </SCSubscriberName>
      <SCSubscribeRole>
        { SubscriberRoleName[subscriber.role] ?? 'Роль пользователя' }
      </SCSubscribeRole>
    </SCSubscriberCard>
  );
};

const SCAvatar = styled(Avatar)`
  margin-bottom: 12px;
`;

const SCSubscribeRole = styled.span`
  ${TextRegStyle};
  color: var(--gray-color);
`;

const SCSubscriberName = styled.span`
  ${TextBoldStyle};
  margin-bottom: 4px;
`;

export const SCSubscriberCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 282px;
  background: var(--white-color);

  border: 1px solid var(--gray2-color);
  box-sizing: border-box;
  box-shadow: 0 1px 1px rgba(141, 147, 162, 0.25);
  border-radius: 4px;
  padding: 16px;
`;
